import * as Yup from "yup";

const validationSchema = Yup.object({
  name: Yup.string().required("FullName is required."),
  gst: Yup.string(),
  state: Yup.object().required("State is required."),
  city: Yup.object().required("City is required."),
  mobileNumber: Yup.string().min(10, "Invalid mobile number.").max(10, "Invalid mobile number."),
  workingCity: Yup.array()
    .min(1, "Working City is required.")
    .required("Working City is required."),
  address: Yup.string(),
});

export { validationSchema };
